module.exports = "//public.getcloudapp.com/packs/media/images/logos-cloud-app-logomark-full-color-fa855f2a995fed9f7aad4a15df5071ea.svg";